export const sizeOfItemsPerPage: number = 6;
